import React, { useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import StarRateIcon from '@mui/icons-material/StarRate';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import House from "../../Assets/images/apa1.png";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'white',
  boxShadow: 24,
  borderRadius: '16px',
  p: 3,
  maxWidth: '95%',
};

function SelectDuration({ open, handleClose, handleContinue, handleBack, data }) {
  const [duration, setDuration] = React.useState('1 year');

  useEffect(() => {
    if (!open) {
      setDuration('1 year');
    }
  }, [open]);

  const images =
    data?.apartmentClassImagesDTOS?.length > 0
      ? data.apartmentClassImagesDTOS.map(img => img?.imageUrl || House)
      : data?.apartmentImages?.length > 0
        ? data.apartmentImages.map(img => img?.imageUrl || House)
        : [House, House, House, House];

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          {/* Header */}
          <div className='flex justify-between items-center mb-6'>
            <div className='flex items-center gap-4 cursor-pointer' onClick={handleBack}>
              <ArrowBackIcon />
              <span className='font-[600] text-[18px] text-[#1E222B]'>Back</span>
            </div>
            <IconButton
              onClick={handleClose}
              sx={{ bgcolor: '#1F2937', color: 'white', '&:hover': { bgcolor: '#374151' }, width: 36, height: 36 }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>

          {/* Apartment Card */}
          <div className='flex gap-4 items-center mb-6 border border-gray-100 shadow-sm rounded-2xl p-3'>
            <img
              src={images[0]}
              alt="Apartment"
              className='w-[100px] h-[100px] rounded-xl object-cover'
            />
            <div className='flex flex-col'>
              <p className='font-[700] text-[16px] text-[#1E222B] leading-tight mb-2'>
                {data?.apartmentTitle || ""}
              </p>
              <p className='flex items-center gap-1 text-[13px] text-[#808285] mb-2'>
                <FmdGoodOutlinedIcon fontSize="small" sx={{ fontSize: '16px' }} />
                {data?.location || ""}
              </p>
              <p className='font-[700] text-[14px] text-[#00BC67]'>
                NGN{data?.price?.toLocaleString() || "0"}<span className='text-gray-500 font-[400] text-[12px]'>/year</span>
              </p>
            </div>
          </div>

          <p className='font-[700] text-[16px] text-[#1E222B] mb-6'>Select duration</p>

          {/* Price and Rating */}
          <div className='flex justify-between items-center mb-6'>
            <p className='font-[700] text-[16px] text-[#00BC67]'>
              NGN{data?.price?.toLocaleString() || "0"}<span className='text-gray-500 font-[400] text-[14px]'>/year</span>
            </p>
            <p className='flex items-center gap-1 text-[14px] font-[500] text-[#1E222B]'>
              <StarRateIcon className='text-[#FFC107]' fontSize='small' /> 4.0 <span className='text-gray-400'>(26)</span>
            </p>
          </div>

          {/* Dropdown */}
          <div className='mb-8'>
            <p className='text-[14px] text-[#1E222B] font-[500] mb-2'>Select rent duration</p>
            <FormControl fullWidth>
              <Select
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                displayEmpty
                sx={{
                  bgcolor: '#F9FAFB',
                  borderRadius: '8px',
                  '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                  color: '#1E222B',
                  fontWeight: 500,
                }}
              >
                <MenuItem value="1 year">1 year</MenuItem>
                <MenuItem value="2 years">2 years</MenuItem>
                <MenuItem value="3 years">3 years</MenuItem>
                <MenuItem value="4 years">4 years</MenuItem>
                <MenuItem value="4 years">5 years</MenuItem>
              </Select>
            </FormControl>
          </div>

          {/* Button */}
          <button
            onClick={() => handleContinue(duration)}
            className='w-full bg-[#00BC67] text-white font-[600] py-3.5 rounded-xl transition-colors text-[16px]'
          >
            Continue
          </button>
        </Box>
      </Fade>
    </Modal>
  );
}

export default SelectDuration;

